export default __webpack_public_path__ + "images/5J.943801d.png";